import {Configuration} from "../api-client";
import {
    AuditApiFactory,
    AuthenticationApiFactory,
    CalendarApiFactory,
    ClinicsApiFactory,  // Renamed from DentalCabinetsApiFactory
    DocumentsApiFactory,
    EmailsApiFactory,  // Renamed from OutboundEmailApiFactory
    FeaturesApiFactory,  // Renamed from FeatureApiFactory
    GoogleCalendarApiFactory,
    InvoicesApiFactory,
    MedicalApiFactory,
    NotificationsApiFactory,
    NzisApiFactory,
    OrganizationsApiFactory,  // Renamed from OrganizationApiFactory
    PatientImportsApiFactory,
    PatientsApiFactory,  // Renamed from PatientApiFactory
    PdfApiFactory,
    PublicApiFactory,
    ReportsApiFactory,
    SelfRegisterApiFactory,
    StatusesApiFactory,
    StripeApiFactory,
    TreatmentsApiFactory,
    UsersApiFactory
} from "../api-client";
import API_BASE_PATH from "../config/apiConfig";

const apiConfig = new Configuration({
    basePath: API_BASE_PATH
});

let _auditApi: ReturnType<typeof AuditApiFactory> | null = null;
let _authenticationApi: ReturnType<typeof AuthenticationApiFactory> | null = null;
let _calendarApi: ReturnType<typeof CalendarApiFactory> | null = null;
let _clinicsApi: ReturnType<typeof ClinicsApiFactory> | null = null;
let _documentApi: ReturnType<typeof DocumentsApiFactory> | null = null;
let _documentsApi: ReturnType<typeof DocumentsApiFactory> | null = null;
let _emailApi: ReturnType<typeof EmailsApiFactory> | null = null;
let _emailsApi: ReturnType<typeof EmailsApiFactory> | null = null;
let _featureApi: ReturnType<typeof FeaturesApiFactory> | null = null;
let _featuresApi: ReturnType<typeof FeaturesApiFactory> | null = null;
let _googleCalendarApi: ReturnType<typeof GoogleCalendarApiFactory> | null = null;
let _googleCalendarV2Api: ReturnType<typeof GoogleCalendarApiFactory> | null = null;
let _invoiceApi: ReturnType<typeof InvoicesApiFactory> | null = null;
let _invoicesApi: ReturnType<typeof InvoicesApiFactory> | null = null;
let _medicalApi: ReturnType<typeof MedicalApiFactory> | null = null;
let _medicalStaffApi: ReturnType<typeof MedicalApiFactory> | null = null;
let _notificationsApi: ReturnType<typeof NotificationsApiFactory> | null = null;
let _nzisApi: ReturnType<typeof NzisApiFactory> | null = null;
let _nzizApi: ReturnType<typeof NzisApiFactory> | null = null;
let _organizationApi: ReturnType<typeof OrganizationsApiFactory> | null = null;
let _organizationsApi: ReturnType<typeof OrganizationsApiFactory> | null = null;
let _patientImportsApi: ReturnType<typeof PatientImportsApiFactory> | null = null;
let _patientApi: ReturnType<typeof PatientsApiFactory> | null = null;
let _patientsApi: ReturnType<typeof PatientsApiFactory> | null = null;
let _pdfApi: ReturnType<typeof PdfApiFactory> | null = null;
let _reportsApi: ReturnType<typeof ReportsApiFactory> | null = null;
let _publicApi: ReturnType<typeof PublicApiFactory> | null = null;
let _selfRegisterApi: ReturnType<typeof SelfRegisterApiFactory> | null = null;
let _statusApi: ReturnType<typeof StatusesApiFactory> | null = null;
let _statusesApi: ReturnType<typeof StatusesApiFactory> | null = null;
let _stripeApi: ReturnType<typeof StripeApiFactory> | null = null;
let _treatmentApi: ReturnType<typeof TreatmentsApiFactory> | null = null;
let _treatmentsApi: ReturnType<typeof TreatmentsApiFactory> | null = null;
let _userApi: ReturnType<typeof UsersApiFactory> | null = null;
let _usersApi: ReturnType<typeof UsersApiFactory> | null = null;

export const getAuditApi = () => {
    if (!_auditApi) {
        _auditApi = AuditApiFactory(apiConfig);
    }
    return _auditApi;
};

export const getAuthenticationApi = () => {
    if (!_authenticationApi) {
        _authenticationApi = AuthenticationApiFactory(apiConfig);
    }
    return _authenticationApi;
};

export const getCalendarApi = () => {
    if (!_calendarApi) {
        _calendarApi = CalendarApiFactory(apiConfig);
    }
    return _calendarApi;
};

// Renamed from getDentalCabinetsApi
export const getClinicsApi = () => {
    if (!_clinicsApi) {
        _clinicsApi = ClinicsApiFactory(apiConfig);
    }
    return _clinicsApi;
};

export const getDocumentApi = () => {
    if (!_documentApi) {
        _documentApi = DocumentsApiFactory(apiConfig);
    }
    return _documentApi;
};

export const getDocumentsApi = () => {
    if (!_documentsApi) {
        _documentsApi = DocumentsApiFactory(apiConfig);
    }
    return _documentsApi;
};

export const getEmailApi = () => {
    if (!_emailApi) {
        _emailApi = EmailsApiFactory(apiConfig);
    }
    return _emailApi;
};

export const getEmailsApi = () => {
    if (!_emailsApi) {
        _emailsApi = EmailsApiFactory(apiConfig);
    }
    return _emailsApi;
};

export const getFeatureApi = () => {
    if (!_featureApi) {
        _featureApi = FeaturesApiFactory(apiConfig);
    }
    return _featureApi;
};

export const getFeaturesApi = () => {
    if (!_featuresApi) {
        _featuresApi = FeaturesApiFactory(apiConfig);
    }
    return _featuresApi;
};

export const getGoogleCalendarApi = () => {
    if (!_googleCalendarApi) {
        _googleCalendarApi = GoogleCalendarApiFactory(apiConfig);
    }
    return _googleCalendarApi;
};

export const getGoogleCalendarV2Api = () => {
    if (!_googleCalendarV2Api) {
        _googleCalendarV2Api = GoogleCalendarApiFactory(apiConfig);
    }
    return _googleCalendarV2Api;
};

export const getInvoiceApi = () => {
    if (!_invoiceApi) {
        _invoiceApi = InvoicesApiFactory(apiConfig);
    }
    return _invoiceApi;
};

export const getInvoicesApi = () => {
    if (!_invoicesApi) {
        _invoicesApi = InvoicesApiFactory(apiConfig);
    }
    return _invoicesApi;
};

export const getMedicalApi = () => {
    if (!_medicalApi) {
        _medicalApi = MedicalApiFactory(apiConfig);
    }
    return _medicalApi;
};

export const getMedicalStaffApi = () => {
    if (!_medicalStaffApi) {
        _medicalStaffApi = MedicalApiFactory(apiConfig);
    }
    return _medicalStaffApi;
};

export const getNotificationsApi = () => {
    if (!_notificationsApi) {
        _notificationsApi = NotificationsApiFactory(apiConfig);
    }
    return _notificationsApi;
};

export const getNzisApi = () => {
    if (!_nzisApi) {
        _nzisApi = NzisApiFactory(apiConfig);
    }
    return _nzisApi;
};

export const getNZIZApi = () => {
    if (!_nzizApi) {
        _nzizApi = NzisApiFactory(apiConfig);
    }
    return _nzizApi;
};

export const getOrganizationApi = () => {
    if (!_organizationApi) {
        _organizationApi = OrganizationsApiFactory(apiConfig);
    }
    return _organizationApi;
};

export const getOrganizationsApi = () => {
    if (!_organizationsApi) {
        _organizationsApi = OrganizationsApiFactory(apiConfig);
    }
    return _organizationsApi;
};

export const getPatientApi = () => {
    if (!_patientApi) {
        _patientApi = PatientsApiFactory(apiConfig);
    }
    return _patientApi;
};

export const getPatientsApi = () => {
    if (!_patientsApi) {
        _patientsApi = PatientsApiFactory(apiConfig);
    }
    return _patientsApi;
};

export const getPdfApi = () => {
    if (!_pdfApi) {
        _pdfApi = PdfApiFactory(apiConfig);
    }
    return _pdfApi;
};

export const getReportsApi = () => {
    if (!_reportsApi) {
        _reportsApi = ReportsApiFactory(apiConfig);
    }
    return _reportsApi;
};

export const getPublicApi = () => {
    if (!_publicApi) {
        _publicApi = PublicApiFactory(apiConfig);
    }
    return _publicApi;
};

export const getSelfRegisterApi = () => {
    if (!_selfRegisterApi) {
        _selfRegisterApi = SelfRegisterApiFactory(apiConfig);
    }
    return _selfRegisterApi;
};

export const getStatusApi = () => {
    if (!_statusApi) {
        _statusApi = StatusesApiFactory(apiConfig);
    }
    return _statusApi;
};

export const getStatusesApi = () => {
    if (!_statusesApi) {
        _statusesApi = StatusesApiFactory(apiConfig);
    }
    return _statusesApi;
};

export const getStripeApi = () => {
    if (!_stripeApi) {
        _stripeApi = StripeApiFactory(apiConfig);
    }
    return _stripeApi;
};

export const getTreatmentApi = () => {
    if (!_treatmentApi) {
        _treatmentApi = TreatmentsApiFactory(apiConfig);
    }
    return _treatmentApi;
};

export const getTreatmentsApi = () => {
    if (!_treatmentsApi) {
        _treatmentsApi = TreatmentsApiFactory(apiConfig);
    }
    return _treatmentsApi;
};

export const getUserApi = () => {
    if (!_userApi) {
        _userApi = UsersApiFactory(apiConfig);
    }
    return _userApi;
};

export const getUsersApi = () => {
    if (!_usersApi) {
        _usersApi = UsersApiFactory(apiConfig);
    }
    return _usersApi;
};

export const getPatientImportApi = () => {
    if (!_patientImportsApi) {
        _patientImportsApi = PatientImportsApiFactory(apiConfig);
    }
    return _patientImportsApi;
};
